import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`navbar navbar-expand-lg navbar-dark px-3 shadow-sm sticky-top transition-all ${
        scrolled ? "bg-dark" : "bg-dark"
      }`}
      style={{ transition: "background 0.3s" }}
    >
      {/* Logo */}
      <NavLink className="navbar-brand d-flex align-items-center" to="/">
        <img
          src="/UF-logo.png"
          alt="Ustadistan Academy Logo"
          style={{
            height: "55px",
            width: "55px",
            objectFit: "contain",
            borderRadius: "50%",
            marginTop: "-5px",
            marginBottom: "-5px",
          }}
        />
        <span
          className="ms-2 fw-bold d-none d-md-inline"
          style={{ fontSize: "1.1rem", letterSpacing: "0.5px" }}
        >
          Ustadistan Academy
        </span>
      </NavLink>

      {/* Mobile toggle */}
      <button
        className="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon"></span>
      </button>

      {/* Links */}
      <div className="collapse navbar-collapse" id="navbarNav">
        <ul className="navbar-nav ms-auto gap-1">
          {[
            { to: "/", label: "Home" },
            { to: "/about", label: "About" },
            { to: "/teachers", label: "Teachers" },
          ].map(({ to, label }) => (
            <li className="nav-item" key={to}>
              <NavLink
                to={to}
                end={to === "/"}
                className={({ isActive }) =>
                  `btn btn-light px-4 py-2 ${isActive ? "fw-bold" : "fw-normal"}`
                }
              >
                {label}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}